import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Studio Dialect Mouse Cursor Logic
document.addEventListener('DOMContentLoaded', () => {
  const cursorCrosshair = document.getElementById('cursor-crosshair')
  const cursorLineX = document.getElementById('cursor-line-x')
  const cursorLineY = document.getElementById('cursor-line-y')
  const cursorCoords = document.getElementById('cursor-coords')
  const projectCards = document.querySelectorAll('.project-card')

  if (cursorCrosshair && cursorLineX && cursorLineY && cursorCoords) {
    window.addEventListener('mousemove', (e) => {
      const posX = e.clientX
      const posY = e.clientY
      
      // Update crosshair position
      cursorCrosshair.style.left = `${posX}px`
      cursorCrosshair.style.top = `${posY}px`
      
      // Update line positions
      cursorLineX.style.left = `${posX}px`
      cursorLineY.style.top = `${posY}px`
      
      // Update coordinates
      cursorCoords.style.left = `${posX}px`
      cursorCoords.style.top = `${posY}px`
      cursorCoords.textContent = `X: ${posX.toString().padStart(3, '0')} Y: ${posY.toString().padStart(3, '0')}`
      cursorCoords.style.background = 'transparent'
      cursorCoords.style.borderColor = 'transparent'
    })

    // Add hover effects for project cards
    projectCards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        document.body.classList.add('cursor-hover')
      })
      card.addEventListener('mouseleave', () => {
        document.body.classList.remove('cursor-hover')
      })
    })
  }
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
